import request from '@/utils/request'

// 查询预约日安排列表
export function listChannelDay(query) {
    return request({
        url: '/biz/channelDay/list',
        method: 'get',
        params: query
    })
}

// 查询预约日安排详细
export function getChannelDay(id) {
    return request({
        url: '/biz/channelDay/' + id,
        method: 'get'
    })
}

// 新增预约日安排
export function addChannelDay(data) {
    return request({
        url: '/biz/channelDay',
        method: 'post',
        data: data
    })
}

// 修改预约日安排
export function updateChannelDay(data) {
    return request({
        url: '/biz/channelDay/update',
        method: 'post',
        data: data
    })
}

// 删除预约日安排
export function delChannelDay(id) {
    return request({
        url: '/biz/channelDay/delete/' + id,
        method: 'post'
    })
}
